import {
  ghostBtnClass,
  mfgConfirmDialogClass,
  mfgSolidDangerBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

/** Confirm archiving multiple selected manufacturing models. */
export function ManufacturingModelsBulkArchiveConfirm({
  open,
  count,
  busy,
  error,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  count: number;
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  if (!open || count <= 0) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mfg-models-bulk-archive-title"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className={`max-w-md ${mfgConfirmDialogClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="mfg-models-bulk-archive-title"
          className="text-base font-semibold text-gray-900 dark:text-zinc-100"
        >
          Archive {count} selected model{count === 1 ? "" : "s"}?
        </h3>
        <p className="text-sm text-gray-600 dark:text-zinc-400">
          This marks them inactive — they stay in the database but are hidden from pickers
          and new BOM lines. Already-archived models are skipped.
        </p>
        {error ? (
          <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
            {error}
          </div>
        ) : null}
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" className={ghostBtnClass} onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className={mfgSolidDangerBtnClass}
            onClick={onConfirm}
            disabled={busy}
            autoFocus
          >
            {busy ? "Archiving…" : "Archive selected"}
          </button>
        </div>
      </div>
    </div>
  );
}
